// https://www.typescriptlang.org/docs/handbook/utility-types.html#nonnullabletype
// filter에 끼워서 사용한다
export function isNonNullable<T>(
	x: T | null | undefined,
): x is NonNullable<typeof x> {
	if (x === undefined) { return false; }
	if (x == null) { return false; }
	return true;
}
